export default "__VITE_ASSET__m$NrtNrU__"